<template>
    <div>
        <div class="text-center">
            <h3 class="mx-auto bg-info text-center" style="width: 85%">{{hobby}}</h3>
            <b-img center class="img-style" :alt="hobby"
                       :src="require('../assets/imgs/hobbies/' + hobby + '.png')"/>
        </div>
        <transition v-if="hobbyPoints" name="slide-fade" mode="out-in">
            <div class="mx-auto" style="width: 85%">
                <b-list-group>
                    <b-card v-if="hobbyPoints" no-body>
                        <b-list-group v-for="point in hobbyPoints" v-bind:key="point">
                            <b-list-group-item>
                                {{point}}
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>

                </b-list-group>
            </div>
        </transition>
        <br/>
    </div>
</template>

<script>
    export default {
        name: "Hobby",
        props: {
            hobby: {
                required: true,
                type: String
            },
            hobbyPoints: {
                type: Array
            }
        }
    }
</script>

<style scoped>

</style>
